import React from "react";
import { styled } from "@mui/material/styles";
import { Box, Stack, Chip } from "@mui/material";
import Logo from "layouts/Drawer/LogoMin";

const DrawerHeader = () => {
  const DrawerHeaderStyled = styled(Box)(({ theme }) => ({
    ...theme.mixins.toolbar,
    display: "flex",
    alignItems: "center",
    justifyContent: "start",
    marginBottom: 20,
    paddingLeft: 26,
  }));

  return (
    <DrawerHeaderStyled>
      <Stack direction="row" spacing={1} alignItems="center">
        <Logo width={165} />
        <Chip
          label={process.env.REACT_APP_VERSION}
          size="small"
          sx={{
            height: 16,
            "& .MuiChip-label": { fontSize: "0.625rem", py: 0.25 },
          }}
        />
      </Stack>
    </DrawerHeaderStyled>
  );
};

export default DrawerHeader;
